module.exports = __webpack_public_path__ + "img/diao_guan_ji1.fda4bd71.png";